<ng-template #dlilBlockUi>
    <p-button
        [pTooltip]="
            !checkIfCanSave()
                ? (saveFirstLabelKey | translate)
                : (missingDataLabelKey | translate)
        "
        [loading]="isSaving"
        icon="fa fa-save"
        [label]="saveFirstLabelKey | translate"
        [disabled]="checkIfCanSave()"
        (onClick)="saveToUnlockEditMode()"
    ></p-button>
</ng-template>

<blockable-div
    #dlilBlock
    [class]="contentFlexClass"
    [blocked]="!model.id"
    [blockUi]="dlilBlockUi"
>
    @if (model.id) {
        <app-new-widget-document-line-item
            #lineitems
            [autoloadItems]="false"
            [fillHeightList]="fillHeightList"
            [noAddNew]="true"
            [noDelete]="true"
            [noCopy]="true"
            [noBaseEdit]="true"
            [noStatusFilter]="false"
            [noTypeFilter]="false"
            [loadDocumentToo]="this.props?.loadDocumentToo"
            [viewName]="this.props?.viewName"
        />
    }
</blockable-div>
